var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.WindPointLayer = new Class({
    Extends: OCS.Viewer.Classes.PointLayer,
    class_name: "WindPointLayer",
    options: {
        style_type: 'wind_barb'
    }
});
